import type { StandingOrders } from './StandingOrders';

export const base: StandingOrders = {
    createSweepOrders: true,
    showReceiverNameFirst: false,
    daysUntilLastOfMonth: 31,
    daysUntilLastOfMonthSweep: 31,
    allowedStoppages: [
        'JANUARY',
        'FEBRUARY',
        'MARCH',
        'APRIL',
        'MAY',
        'JUNE',
        'JULY',
        'AUGUST',
        'SEPTEMBER',
        'OCTOBER',
        'NOVEMBER',
        'DECEMBER',
    ],
    standingOrderIntervals: [],
    daysFromTodayOutsideRange: 0,
    sweepOrderIntervals: [],
    daysOfRepetition: 0,
    useVariableCurrencyForIntrabankIban: false,
    useVariableCurrencyFromReceiverAPI: false,
    fetchReceiver: false,
    handleLocalErrors: {
        errorCode: '',
        translationPath: '',
    },
    executionModes: ['UNTIL_CANCELLATION', 'UNTIL_DATE'],
    executionModesSweep: ['UNTIL_CANCELLATION', 'UNTIL_DATE'],
    disableCurrencySelectOnEdit: false,
    disableExecutionIntervalSelectOnEdit: false,
    disableReceiverChangeOnEdit: true,
    invalidateCacheAfterMutation: false,
    historyScheduledExecutionDates: false,
};
